import React from "react";
import "./AQWpackages.css";
import { createIcons, icons } from "lucide";
const PackagesComponent = () => {
  const { useState, useEffect } = React;
  const [config, setConfig] = useState({
    brand_name: "NovaSoft",
    tagline: "Powerful tools for every kind of team",
    basic_title: "Basic",
    basic_price: "CORE",
    pro_title: "Professional",
    pro_price: "ANALYTIC",
    premium_title: "Premium",
    premium_price: "ENTERPRISE",
    cta_text: "Get Started Free",
    footer_text: "© 2025 NovaSoft. All rights reserved."
  });
  useEffect(() => {
    // Initialize icons, replacing data-lucide tags
    createIcons({ icons });
  }, []);
  return (
    <div>
      <section id="plans" style={{ padding: "72px 24px" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <p style={{ fontSize: "12px", fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--accent)", margin: "0 0 10px" }}>PACKAGES</p>
            <h2 style={{ fontSize: "clamp(28px, 4vw, 44px)", margin: "0 0 14px", fontWeight: 400 }}>Three plans, adapted to your needs</h2>
            <p style={{ color: "var(--muted)", fontSize: "16px", margin: 0 }}>Scale as you grow.</p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "24px", alignItems: "stretch" }}>
            <div className="plan-card" style={{ padding: "32px", display: "flex", flexDirection: "column" }}>
              <div style={{ marginBottom: "24px" }}>
                <div className="badge" style={{ background: "rgba(255,255,255,0.07)", color: "var(--muted)", border: "1px solid rgba(255,255,255,0.1)", marginBottom: "16px" }}>
                  <i data-lucide="box" style={{ width: "11px", height: "11px" }} />
                  <span>{config.basic_title}</span>
                </div>
                <div style={{ display: "flex", alignItems: "flex-end", gap: "6px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "28px", fontWeight: 700, lineHeight: 1 }}>{config.basic_price}</span>
                  <span style={{ fontSize: "14px", color: "var(--muted)", fontWeight: 400, marginBottom: "8px" }}>/monthly</span>
                </div>
                <p style={{ color: "var(--muted)", fontSize: "14px", margin: 0 }}>Visualize current conditions</p>
              </div>
              <div style={{ borderTop: "1px solid rgba(255,255,255,0.07)", paddingTop: "24px", marginBottom: "28px", display: "flex", flexDirection: "column", gap: "14px", flex: 1 }}>
                {["Real-Time Data​", "Threshold alarms​",  "Core analytics dashboard", "Software as a Service (AquaCARE):​ "].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="check-circle" style={{ width: "16px", height: "16px", color: "#4f8ef7", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--text)" }}>{feature}</span>
                  </div>
                ))}
                {["30 min weekly first month​", "After first month hourly rate", "RAS expert on demand (​Up to 3 projects)"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="minus" style={{ width: "16px", height: "16px", color: "var(--muted)", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--muted)" }}>{feature}</span>
                  </div>
                ))}
                {["Support by email/phone: 8-16​"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="headset" style={{ width: "16px", height: "16px", color: "#9ED3CD", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--text)" }}>{feature}</span>
                  </div>
                ))}
              </div>
              <button className="btn-ghost" style={{ width: "100%", padding: "13px", marginTop: "auto", height: "48px" }}>
                Choose Basic
              </button>
            </div>

            <div className="plan-card featured" style={{ padding: "32px", display: "flex", flexDirection: "column" }}>
              <div style={{ marginBottom: "24px" }}>
                <div className="badge" style={{ background: "rgba(158, 211, 205, 0.15)", color: "#9ED3CD", border: "1px solid rgba(158, 211, 205, 0.3)", marginBottom: "16px" }}>
                  <i data-lucide="star" style={{ width: "11px", height: "11px" }} />
                  <span>{config.pro_title}</span>
                </div>
                <div style={{ display: "flex", alignItems: "flex-end", gap: "6px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "28px", fontWeight: 700, lineHeight: 1, color: "#9ED3CD" }}>{config.pro_price}</span>
                  <span style={{ fontSize: "14px", color: "var(--muted)", fontWeight: 400, marginBottom: "8px" }}>/monthly</span>
                </div>
                <p style={{ color: "var(--muted)", fontSize: "14px", margin: 0 }}>Control over water quality</p>
              </div>
              <div style={{ borderTop: "1px solid rgba(158, 211, 205, 0.2)", paddingTop: "24px", marginBottom: "28px", display: "flex", flexDirection: "column", gap: "14px", flex: 1 }}>
                {["Core ++", "Integration to SCADA - automation", "Alkalinity​", "Client data integration​", "Software as a Service (AquaCARE):"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="check-circle" style={{ width: "16px", height: "16px", color: "#9ED3CD", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--text)" }}>{feature}</span>
                  </div>
                ))}
                {["30 min weekly", "30 min monthly​", "RAS expert on demand"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="minus" style={{ width: "16px", height: "16px", color: "var(--muted)", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--muted)" }}>{feature}</span>
                  </div>
                ))}
                {["Support by email/phone: 8-22​"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="headset" style={{ width: "16px", height: "16px", color: "#9ED3CD", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--text)" }}>{feature}</span>
                  </div>
                ))}
              </div>
              <button className="btn-primary" style={{ width: "100%", padding: "13px", marginTop: "auto", height: "48px" }}>
                Choose Professional
              </button>
            </div>

            <div className="plan-card premium-card" style={{ padding: "32px", display: "flex", flexDirection: "column" }}>
              <div style={{ marginBottom: "24px" }}>
                <div className="badge" style={{ background: "rgba(255, 173, 96, 0.15)", color: "#FFAD60", border: "1px solid rgba(255, 173, 96, 0.3)", marginBottom: "16px" }}>
                  <i data-lucide="crown" style={{ width: "11px", height: "11px" }} />
                  <span>{config.premium_title}</span>
                </div>
                <div style={{ display: "flex", alignItems: "flex-end", gap: "6px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "28px", fontWeight: 700, lineHeight: 1, color: "#FFAD60" }}>{config.premium_price}</span>
                  <span style={{ fontSize: "14px", color: "var(--muted)", fontWeight: 400, marginBottom: "8px" }}>/monthly</span>
                </div>
                <p style={{ color: "var(--muted)", fontSize: "14px", margin: 0 }}>Maximize operational performance</p>
              </div>
              <div style={{ borderTop: "1px solid rgba(255, 173, 96, 0.2)", paddingTop: "24px", marginBottom: "28px", display: "flex", flexDirection: "column", gap: "14px", flex: 1 }}>
                {["Analytic ++", "TIC-sensor​", "Degassing, Mass balance​", "Forecast and biomass estimations", "Simulators​", "Software as a Service (AquaCARE):"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="check-circle" style={{ width: "16px", height: "16px", color: "#FFAD60", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--text)" }}>{feature}</span>
                  </div>
                ))}
                {["30 min daily​ with RAS expert", "Technical analysis for facility on the demand​", "Strategy for operations on demand"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="minus" style={{ width: "16px", height: "16px", color: "var(--muted)", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--muted)" }}>{feature}</span>
                  </div>
                ))}
                {["Support by email/phone: 24/7​"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="headset" style={{ width: "16px", height: "16px", color: "#9ED3CD", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--text)" }}>{feature}</span>
                  </div>
                ))}
                {["Remote Control Center @Searas​"].map(feature => (
                  <div key={feature} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                    <i data-lucide="cctv" style={{ width: "16px", height: "16px", color: "#9ED3CD", flexShrink: 0 }} />
                    <span style={{ fontSize: "14px", color: "var(--text)" }}>{feature}</span>
                  </div>
                ))}
              </div>
              <button className="btn-gold" style={{ width: "100%", padding: "13px", marginTop: "auto", height: "48px" }}>
                Choose Premium
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default PackagesComponent;
